import { gql } from '@apollo/client';

export const ALL_LOCAL_MUNICIPALITIES = gql`
  query AllLocalMunicipalities($input: FilterLocalMunicipalityInput!) {
    municipalities: getLocalMunicipalities(input: $input) {
      id
      localMunicipality
      localMunicipalityShorthand
    }
  }
`;
